import { gql } from '@apollo/client';

export const CLICKABLE_COUNTRY_QUERY = gql`
  query mapInteractiveCountries($filters: JSON, $selectedCountry: JSON) {
    mapInteractiveCountries(filters: $filters, selectedCountry: $selectedCountry) {
      feature
    }
  }
`;
